
export const messageFrontEnd = () => {
    // * MENSAJE A MOSTRAR DE UN ERROR 500 EN API.
    return "Por favor, comunicarse con el departamento de Desarrollo e Implentación de Sistemas.";  
}